"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcStepperBehavior = exports.ThemeCircles = void 0;
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_stepper_constants_1 = require("./bc-stepper-constants");
var bc_stepper_constants_2 = require("./bc-stepper-constants");
var bc_stepper_constants_3 = require("./bc-stepper-constants");
var bc_stepper_constants_4 = require("./bc-stepper-constants");
var bc_stepper_constants_5 = require("./bc-stepper-constants");
var bc_stepper_constants_6 = require("./bc-stepper-constants");
var bc_stepper_constants_7 = require("./bc-stepper-constants");
var bc_stepper_constants_8 = require("./bc-stepper-constants");
var bc_stepper_constants_9 = require("./bc-stepper-constants");
var bc_stepper_constants_10 = require("./bc-stepper-constants");
var bc_stepper_constants_11 = require("./bc-stepper-constants");
var bc_stepper_constants_12 = require("./bc-stepper-constants");
var bc_stepper_constants_13 = require("./bc-stepper-constants");
var bc_stepper_constants_14 = require("./bc-stepper-constants");
var bc_stepper_constants_15 = require("./bc-stepper-constants");
var bc_stepper_constants_16 = require("./bc-stepper-constants");
var bc_stepper_constants_17 = require("./bc-stepper-constants");
var bc_stepper_constants_18 = require("./bc-stepper-constants");
var bc_stepper_constants_19 = require("./bc-stepper-constants");
var bc_stepper_constants_20 = require("./bc-stepper-constants");
var bc_stepper_constants_21 = require("./bc-stepper-constants");
var bc_stepper_constants_22 = require("./bc-stepper-constants");
var ThemeCircles;
(function (ThemeCircles) {
    ThemeCircles[ThemeCircles["LIGHT"] = 0] = "LIGHT";
    ThemeCircles[ThemeCircles["DARK"] = 1] = "DARK";
})(ThemeCircles = exports.ThemeCircles || (exports.ThemeCircles = {}));
var BcStepperBehavior = (function (_super) {
    __extends(BcStepperBehavior, _super);
    function BcStepperBehavior() {
        var _this = _super.call(this) || this;
        _this.maxStep = 0;
        _this.currentStep = 0;
        _this.initialStep = 0;
        _this.progressHeader = 0;
        _this.status = [];
        _this.labels = [];
        _this.isTop = false;
        _this.themeCircles = ThemeCircles.DARK;
        return _this;
    }
    BcStepperBehavior.prototype._setUp = function () {
        this.isMobile = this.checkCurrentWidth();
        this.createBulletSteps();
        this.addClickEvent();
        this.addClickEventHeader();
        this.addResizeEvent();
        this.getElement();
        this.setInitState();
        this.setIndexStatus();
        this.setBulletStatus();
        this.checkStepperDirection();
        this.accessibility();
        this.scrollEventHeader();
    };
    BcStepperBehavior.prototype.setThemeCircles = function (themeCircles) {
        this.themeCircles = themeCircles;
    };
    BcStepperBehavior.prototype.setDirection = function () {
        if (this.mySelf.classList.contains(bc_stepper_constants_2.STEPPER_VERTICAL)) {
            this.direction = bc_stepper_constants_18.STEPPER_VERTICAL_DIRECTION;
        }
        else {
            this.direction = bc_stepper_constants_17.STEPPER_HORIZONTAL_DIRECTION;
        }
        this.checkStepperDirection();
    };
    BcStepperBehavior.prototype.setNumStep = function (numSteps) {
        this.numSteps = numSteps;
        this.maxStep = numSteps;
        if (this.direction === bc_stepper_constants_17.STEPPER_HORIZONTAL_DIRECTION) {
            this.setProgressHorizontal();
        }
        else {
            this.setProgressVertical();
        }
    };
    BcStepperBehavior.prototype.setProgressHorizontal = function () {
        this.width = bc_stepper_constants_19.STEPPER_N100 / (this.numSteps - 1);
    };
    BcStepperBehavior.prototype.setProgressVertical = function () {
        this.height = bc_stepper_constants_19.STEPPER_N100 / (this.numSteps - 1);
    };
    BcStepperBehavior.prototype.setLabels = function (labels) {
        this.setDirection();
        this.labels = labels;
        this.setNumStep(this.labels.length);
    };
    BcStepperBehavior.prototype.getElement = function () {
        this.progressStepArray = Array.from(this.mySelf.querySelectorAll(".".concat(bc_stepper_constants_3.STEPPER_PROGRESS_STEP)));
        this.progressBulletArray = Array.from(this.mySelf.querySelectorAll(".".concat(bc_stepper_constants_5.STEPPER_INNER_BULLET)));
        this.progressTrack = this.mySelf.querySelector(".".concat(bc_stepper_constants_4.STEPPER_PROGRESS_TRACK));
    };
    BcStepperBehavior.prototype.setInitIndexPosition = function (index) {
        if (index >= 0 && index < this.labels.length) {
            this.setCurrentStep(index);
        }
    };
    BcStepperBehavior.prototype.setInitState = function () {
        this.status[this.currentStep] = bc_stepper_constants_14.STEPPER_IS_ACTIVE;
        this.setProgressHeader();
    };
    BcStepperBehavior.prototype.click = function (index) {
        {
            if (index < this.currentStep) {
                this.status[this.currentStep] = bc_stepper_constants_15.STEPPER_IS_DEFAULT;
                this.setCurrentStep(index);
                this.status[this.currentStep] = bc_stepper_constants_14.STEPPER_IS_ACTIVE;
                this.setBulletStatus();
            }
        }
    };
    BcStepperBehavior.prototype.addClickEvent = function () {
        var _this = this;
        this.mySelf.querySelectorAll(".".concat(bc_stepper_constants_3.STEPPER_PROGRESS_STEP)).forEach(function (element, index) {
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.click(index);
            });
        });
    };
    BcStepperBehavior.prototype.addResizeEvent = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function (event) {
            _this.checkStepperDirection();
        });
    };
    BcStepperBehavior.prototype.checkStepperDirection = function () {
        this.isMobile = this.checkCurrentWidth();
        if (this.isMobile && this.mySelf.classList.contains("".concat(bc_stepper_constants_1.STEPPER_HORIZONTAL))) {
            this.mySelf.classList.remove("".concat(bc_stepper_constants_1.STEPPER_HORIZONTAL));
            this.mySelf.classList.add("".concat(bc_stepper_constants_2.STEPPER_VERTICAL));
        }
        else if (!this.isMobile && this.direction === bc_stepper_constants_17.STEPPER_HORIZONTAL_DIRECTION && this.mySelf.classList.contains("".concat(bc_stepper_constants_2.STEPPER_VERTICAL))) {
            this.mySelf.classList.remove("".concat(bc_stepper_constants_2.STEPPER_VERTICAL));
            this.mySelf.classList.add("".concat(bc_stepper_constants_1.STEPPER_HORIZONTAL));
            var elements = this.mySelf.querySelectorAll("section.".concat(bc_stepper_constants_21.STEPPER_NAME, "-step"));
            elements.forEach(function (e) { return e.setAttribute('tabindex', '5'); });
        }
    };
    BcStepperBehavior.prototype.setValue = function (value) {
        var currentState = this.getCurrentState();
        var diference = value - currentState;
        if (diference > 0) {
            for (var i = 0; i < diference; i++) {
                this.next();
            }
        }
        else {
            for (var i = 0; i < diference * -1; i++) {
                this.back();
            }
        }
    };
    BcStepperBehavior.prototype.checkCurrentWidth = function () {
        var isMobile = false;
        if (window.innerWidth <= bc_stepper_constants_20.STEPPER_RESOLUTION_MOBILE) {
            isMobile = true;
        }
        return isMobile;
    };
    BcStepperBehavior.prototype.createBulletSteps = function () {
        this.mySelf.classList.add(bc_stepper_constants_21.STEPPER_NAME);
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, 'true');
        var bulletChild = document.createElement('header');
        bulletChild.classList.add(bc_stepper_constants_22.STEPPER_HEADER);
        bulletChild.innerHTML = "\n        <div class=\"".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-left \" tabindex=\"3\" aria-labelledby=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-number\" aria-posinset=\"3\" >\n          <div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-number\" id=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-number\">").concat(this.currentStep + 1, " de ").concat(this.maxStep, "</div>\n          <div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-circle\">\n            <div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-bar left\"><div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-progress\"></div></div>\n            <div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-bar right\"><div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-progress\"></div></div>\n          </div>\n        </div>\n        <div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-header-center\">\n          <h6 tabindex=\"1\" aria-posinset=\"1\" aria-label=\"paso actual\">").concat(this.labels[this.currentStep], "</h6>\n          <p tabindex=\"2\" aria-posinset=\"2\" aria-label=\"paso siguiente\">Siguiente: ").concat(this.labels[this.currentStep + 1], "</p>\n        </div>\n        <div class=\"").concat(bc_stepper_constants_21.STEPPER_NAME, "-header-right\" tabindex=\"4\" aria-posinset=\"4\" aria-label=\"mostrar u ocultar pasos\" >\n        <em class=\"bc-icon\" alt=\"Arrow down\">").concat(common_constants_1.BcCommonConstants.ICON_ARROW_DOWN, "</em>\n      </div>");
        this.mySelf.appendChild(bulletChild);
        this.settingAtributes();
    };
    BcStepperBehavior.prototype.settingAtributes = function () {
        var _this = this;
        var stepperBulletColor = '';
        var _loop_1 = function (i) {
            var bulletChild = document.createElement('section');
            bulletChild.classList.add(bc_stepper_constants_3.STEPPER_PROGRESS_STEP);
            bulletChild.setAttribute(common_constants_1.BcCommonConstants.ROLE, 'tab');
            bulletChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET, i.toString());
            bulletChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'false');
            if (this_1.themeCircles == ThemeCircles.DARK) {
                stepperBulletColor = bc_stepper_constants_6.STEPPER_INNER_BULLET_ACTIVE;
            }
            else {
                stepperBulletColor = bc_stepper_constants_7.STEPPER_INNER_BULLET_ACTIVE_LIGHT;
            }
            bulletChild.innerHTML = "<section class=\"".concat(bc_stepper_constants_5.STEPPER_INNER_BULLET, "\"></section>\n      <section class=\"").concat(stepperBulletColor, "\"></section>\n      <label class=\"").concat(bc_stepper_constants_8.STEPPER_INNER_NUMBER, "\" aria-hidden=\"true\">").concat(i, "</label>\n      <section class=\"").concat(bc_stepper_constants_9.STEPPER_STATUS, "\"><em class=\"bc-icon\" alt=\"Paso completado\">ok</em></section>\n      <section class=\"").concat(bc_stepper_constants_10.STEPPER_LABEL, "\" aria-hidden=\"true\"><label>").concat(this_1.labels[i - 1], "</label></section>");
            this_1.mySelf.appendChild(bulletChild);
            var bulletItem = bulletChild.querySelector(".".concat(bc_stepper_constants_5.STEPPER_INNER_BULLET));
            (0, helpers_1.addFocusable)(bulletItem, { label: this_1.labels[i - 1] }, { event: function () { return _this.click(i - 1); } });
        };
        var this_1 = this;
        for (var i = 1; i <= this.labels.length; i++) {
            _loop_1(i);
        }
    };
    BcStepperBehavior.prototype.accessibility = function () {
        var _this = this;
        this.mySelf.querySelectorAll("*[class*=\"".concat(bc_stepper_constants_3.STEPPER_PROGRESS_STEP, "\"]")).forEach(function (element, index) {
            (0, helpers_1.addFocusable)(element, { tabindex: '5' }, { event: function () { return _this.decide(element, index); } });
            _this.screenReader(element, index);
        });
        var arrowHeader = this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-right"));
        (0, helpers_1.addFocusable)(arrowHeader, {}, { event: function () { return _this.openSteps(arrowHeader); } });
    };
    BcStepperBehavior.prototype.openSteps = function (element) {
        element.click();
    };
    BcStepperBehavior.prototype.decide = function (element, index) {
        if (element.classList.contains(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT)) {
            if (index === this.currentStep + 1) {
                this.next();
            }
            else if (index === this.currentStep - 1) {
                this.back();
            }
        }
    };
    BcStepperBehavior.prototype.screenReader = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                _this.focusNext(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                _this.focusBack(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                _this.focusHomeEnd(index, true);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
                _this.focusHomeEnd(index);
            }
        });
    };
    BcStepperBehavior.prototype.focusHomeEnd = function (index, key) {
        if (key === void 0) { key = false; }
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = this.initialStep;
            }
            else {
                index = this.labels.length - 1;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcStepperBehavior.prototype.focusNext = function (index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.labels.length - 1) {
                index++;
            }
            else {
                index = this.initialStep;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
            this.getStatus(index);
        }
    };
    BcStepperBehavior.prototype.focusBack = function (index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            else {
                index = this.labels.length - 1;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
            this.getStatus(index);
        }
    };
    BcStepperBehavior.prototype.getStatus = function (index) {
        if (this.status[index] === bc_stepper_constants_14.STEPPER_IS_ACTIVE) {
            this.currentStep = index;
        }
    };
    BcStepperBehavior.prototype.getCurrentElement = function (index) {
        return this.mySelf.querySelectorAll("*[class*=\"".concat(bc_stepper_constants_3.STEPPER_PROGRESS_STEP, "\"]"))[index];
    };
    BcStepperBehavior.prototype.progressHorizontal = function () {
        var currentStepStr = this.currentStep.toString();
        this.progressTrack.style.width = typeof (this.currentStep) === 'string' && this.currentStep != 0
            ? this.commonProgress(this.width, currentStepStr, 0)
            : this.commonProgress(this.width, currentStepStr, 1);
    };
    BcStepperBehavior.prototype.progressVertical = function () {
        var currentStepStr = this.currentStep.toString();
        this.progressTrack.style.height = typeof (this.currentStep) === 'string' && this.currentStep != 0
            ? this.commonProgress(this.height, currentStepStr, 0)
            : this.commonProgress(this.height, currentStepStr, 1);
    };
    BcStepperBehavior.prototype.commonProgress = function (size, currentStep, step) {
        return size * (parseInt(currentStep) + step) + '%';
    };
    BcStepperBehavior.prototype.setIndexStatus = function () {
        var maxLength = this.currentStep;
        for (var index = 0; index < maxLength; index++) {
            this.next(index, false);
        }
    };
    BcStepperBehavior.prototype.next = function (index, notify, accesibility) {
        if (index === void 0) { index = this.currentStep; }
        if (notify === void 0) { notify = true; }
        if (accesibility === void 0) { accesibility = false; }
        if (index < this.labels.length - 1) {
            this.status[index] = bc_stepper_constants_16.STEPPER_IS_COMPLETE;
            index++;
            if (index > this.maxStep) {
                this.maxStep = index;
            }
            this.status[index] = bc_stepper_constants_14.STEPPER_IS_ACTIVE;
            if (this.direction === bc_stepper_constants_17.STEPPER_HORIZONTAL_DIRECTION) {
                this.progressHorizontal();
            }
            else {
                this.progressVertical();
            }
            this.setBulletStatus(accesibility);
        }
        if (notify) {
            this.setCurrentStep(index);
        }
        else {
            this.currentStep = index;
        }
        this.setProgressHeader();
        this.setCurrentStepHeader();
    };
    BcStepperBehavior.prototype.back = function (accesibility) {
        if (accesibility === void 0) { accesibility = false; }
        if (this.currentStep > 0) {
            this.status[this.currentStep] = bc_stepper_constants_16.STEPPER_IS_COMPLETE;
            this.setCurrentStep(this.currentStep - 1);
            this.status[this.currentStep] = bc_stepper_constants_14.STEPPER_IS_ACTIVE;
            this.setBulletStatus(accesibility);
            this.setProgressHeader();
            this.setCurrentStepHeader();
        }
    };
    BcStepperBehavior.prototype.setBulletStatus = function (accesibility) {
        var _this = this;
        if (accesibility === void 0) { accesibility = false; }
        this.status.forEach(function (element, index) {
            var defaultCase = function () {
                _this.progressBulletArray[index].classList.remove(bc_stepper_constants_11.STEPPER_ACTIVE_STEP);
                _this.progressBulletArray[index].classList.add(bc_stepper_constants_12.STEPPER_DEFAULT_STEP);
                _this.progressStepArray[index].classList.remove(bc_stepper_constants_11.STEPPER_ACTIVE_STEP);
            };
            switch (element) {
                case bc_stepper_constants_14.STEPPER_IS_ACTIVE:
                    _this.progressBulletArray[index].classList.remove(bc_stepper_constants_12.STEPPER_DEFAULT_STEP, bc_stepper_constants_13.STEPPER_COMPLETE_STEP);
                    _this.progressBulletArray[index].classList.add(bc_stepper_constants_11.STEPPER_ACTIVE_STEP);
                    _this.progressStepArray[index].classList.add(bc_stepper_constants_11.STEPPER_ACTIVE_STEP);
                    _this.progressStepArray[index].setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'true');
                    break;
                case bc_stepper_constants_15.STEPPER_IS_DEFAULT:
                    defaultCase();
                    break;
                case bc_stepper_constants_16.STEPPER_IS_COMPLETE:
                    _this.progressBulletArray[index].classList.remove(bc_stepper_constants_11.STEPPER_ACTIVE_STEP);
                    _this.progressBulletArray[index].classList.add(bc_stepper_constants_13.STEPPER_COMPLETE_STEP);
                    _this.progressStepArray[index].classList.remove(bc_stepper_constants_11.STEPPER_ACTIVE_STEP);
                    _this.progressStepArray[index].setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'false');
                    break;
                default:
                    defaultCase();
            }
        });
    };
    BcStepperBehavior.prototype.setCurrentStep = function (index) {
        this.currentStep = index;
        if (this.outputFunction) {
            this.outputFunction(index);
        }
    };
    BcStepperBehavior.prototype.getCurrentState = function () {
        return this.currentStep;
    };
    BcStepperBehavior.prototype.setProgressHeader = function () {
        this.progressHeader = ((this.currentStep + 1) / this.maxStep) * bc_stepper_constants_19.STEPPER_N100;
        var progressDeg = bc_stepper_constants_1.STEPPER_N360 * this.progressHeader / bc_stepper_constants_19.STEPPER_N100;
        if (this.progressHeader < bc_stepper_constants_1.STEPPER_N50) {
            this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-left .left .").concat(bc_stepper_constants_21.STEPPER_NAME, "-progress"))['style'].transform = 'rotate(' + progressDeg + 'deg)';
            this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-left .right .").concat(bc_stepper_constants_21.STEPPER_NAME, "-progress"))['style'].transform = 'rotate(0deg)';
        }
        else {
            this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-left .left .").concat(bc_stepper_constants_21.STEPPER_NAME, "-progress"))['style'].transform = 'rotate(180deg)';
            this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-left .right .").concat(bc_stepper_constants_21.STEPPER_NAME, "-progress"))['style'].transform = 'rotate(' + (progressDeg - bc_stepper_constants_1.STEPPER_N180) + 'deg)';
        }
        this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-left .").concat(bc_stepper_constants_21.STEPPER_NAME, "-number")).innerHTML =
            "".concat(this.currentStep + 1, " de ").concat(this.maxStep);
    };
    BcStepperBehavior.prototype.setCurrentStepHeader = function () {
        var currentStep = this.labels[this.currentStep];
        var nextStep = this.labels[this.currentStep + 1] ? "Siguiente: ".concat(this.labels[this.currentStep + 1]) : '';
        this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-center > h6")).innerHTML = currentStep;
        this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-center > p")).innerHTML = nextStep;
    };
    BcStepperBehavior.prototype.addClickEventHeader = function () {
        var _this = this;
        this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header-right")).addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            event.target['classList'].toggle("active");
            var isExpanded = _this.mySelf.getAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED) === 'true' ? 'false' : 'true';
            _this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, isExpanded);
            var elements = _this.mySelf.querySelectorAll("section.".concat(bc_stepper_constants_21.STEPPER_NAME, "-step"));
            elements.forEach(function (e) {
                e.classList.toggle('hidden-step');
                isExpanded === 'true' ? e.setAttribute('tabindex', '5') : e.setAttribute('tabindex', '-1');
            });
        });
    };
    BcStepperBehavior.prototype.scrollEventHeader = function () {
        var _this = this;
        window.addEventListener('scroll', function (e) {
            var rect = _this.mySelf.getBoundingClientRect();
            var elemTop = rect.top;
            var heightClient = _this.mySelf.querySelector(".".concat(bc_stepper_constants_21.STEPPER_NAME, "-header")).clientHeight;
            if (elemTop === 0 && !_this.isTop) {
                _this.mySelf.querySelector('header').classList.add('isTop');
                _this.isTop = true;
                return;
            }
            if (elemTop > heightClient && _this.isTop) {
                _this.mySelf.querySelector('header').classList.remove('isTop');
                _this.isTop = false;
            }
        });
    };
    return BcStepperBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcStepperBehavior = BcStepperBehavior;
